import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
  onError?: (error: Error, info: ErrorInfo) => void;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    this.props.onError?.(error, info);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.fallback) {
      return this.props.fallback(error, () => this.setState({ error: null }));
    }
    return (
      <div
        role="alert"
        style={{
          padding: 24,
          margin: 16,
          border: '1px solid #ffa39e',
          background: '#fff1f0',
          color: '#cf1322',
          borderRadius: 4,
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 8 }}>页面发生错误</div>
        <div style={{ fontSize: 13, opacity: 0.8 }}>{error.message}</div>
        <button
          type="button"
          onClick={() => this.setState({ error: null })}
          style={{
            marginTop: 12,
            padding: '4px 12px',
            border: '1px solid #cf1322',
            background: 'transparent',
            color: '#cf1322',
            cursor: 'pointer',
            borderRadius: 4,
          }}
        >
          重试
        </button>
      </div>
    );
  }
}
